import IconArrowRightLarge from '@picsart/icons/IconArrowRightLarge';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import analytics from '../../services/analytics';

import useStyles from './styles';

function SeeAllFonts() {
  const classes = useStyles();
  const { t } = useTranslation();
  const onClick = () => {
    analytics.pageClick({
      page_path: window.location.pathname,
      action_type: 'see_all_fonts',
    });
  };

  return (
    <div className={classes.root}>
      <div className={classes.heading}>{t('seeAll.title')}</div>
      <Link href="/">
        <a className={classes.link} onClick={onClick}>
          {t('seeAll.link')} <IconArrowRightLarge className={classes.icon} />
        </a>
      </Link>
    </div>
  );
}

export default SeeAllFonts;
